import {useContext} from "react";
import Col from "react-bootstrap/Col";
import {useFormik} from "formik";
import {object, string} from "yup";
import Form from "react-bootstrap/Form";
import Field from "../../ui/form/Field";
import ExecutionsAPI from "../../../services/ExecutionsAPI";
import AuthContext from "../../../contexts/AuthContext";
import {useStoreExecutions} from "../../../store/useStoreExecutions";
import AlertCustom from "../../ui/alert/AlertCustom";

interface RefusalFormInterface {
    refus: any[],
    order: Object,
    setShowModal: Function,
    setModalContent: Function,
}

export const RefusalForm = ({refus, order, setShowModal, setModalContent}: RefusalFormInterface) => {
    const {user} = useContext(AuthContext);
    const getExecutions = useStoreExecutions((state) => state.getExecutions);

    const validationSchemaRefus = object().shape({
        refus: string().ensure().required('* Veuillez renseigner un motif.'),
        refusmessage: string()
            .when('refus', {
                is: (value) => value === '5',
                then: (schema) =>
                    schema
                        .required('Ce champ est requis.')
            }),
    });

    const postRefus = async (values, order) => {
        try {
            await ExecutionsAPI.postExecutions({
                etatextranet: Number.parseInt(order.item.actions[order.id].id, 10),
                etatextranetlibelle: order.item.actions[order.id].label,
                idsgribouil: order.item.idsgribouil,
                numcde: order.item.numcde,
                motif: formikRefus.values.refus,
                motifdesc: formikRefus.values.refusmessage,
            });

            getExecutions(user, true, false);
            setShowModal(false);
        } catch (error) {
            setModalContent((
                <AlertCustom
                    variant={'danger'}
                    heading={true}
                    bodyContent={error.response.data.detail}
                    transition={true}
                />
            ));
        }
    }

    const formikRefus = useFormik({
        initialValues: {
            refus: null,
            refusmessage: '',
        },
        enableReinitialize: true,
        validationSchema: validationSchemaRefus,
        validateOnChange: true,
        onSubmit: (values) => {
            postRefus(values, order);
        },
    })

    return (
        <Col className={'text-left'}>
            <Form
                onSubmit={(event) => {
                    setShowModal(true)
                    event.preventDefault()
                    formikRefus.handleSubmit()
                }}
                className={'mb-3'}
                id={'refusalForm'}>
                <Form.Group controlId={'refusalFormRadios'}>
                    {refus?.map((item, index) => (
                        <Form.Check
                            key={index}
                            id={`refus-${item.refusIdx}`}
                            name={'refus'}
                            type={'radio'}
                            label={item.refusDesc}
                            value={item.refusIdx}
                            className={`mb-2 ${
                                formikRefus.errors.refus ? 'text-danger' : ''
                            }`}
                            onChange={(event) =>
                                formikRefus.setFieldValue(
                                    'refus',
                                    event.target.value,
                                )
                            }
                        />
                    ))}
                    {formikRefus.errors.refus && (
                        <p className={'text-danger'}>
                            {formikRefus.errors.refus}
                        </p>
                    )}
                    {['1', '5'].includes(formikRefus.values.refus) && (
                        <Field
                            as={'textarea'}
                            rows={8}
                            name={'refusmessage'}
                            value={formikRefus.values.refusmessage}
                            onChange={formikRefus.handleChange}
                            placeholder={`Merci de préciser le motif ${
                                formikRefus.values.refus === '5' ? '*' : ''
                            }`}
                            fieldClassNames={'bg-white'}
                            classNames={'mt-3'}
                            error={
                                formikRefus.touched.refusmessage &&
                                formikRefus.errors.refusmessage
                            }
                        />
                    )}
                </Form.Group>
            </Form>
        </Col>
    )
}
